import { getFirestore } from "firebase/firestore";
import firebase_app from "@/firebase/config";

// Reuse the single shared Firebase app so every page gets the correct
// storageBucket - a second config here previously hardcoded a nonexistent
// .appspot.com bucket and poisoned whichever pages loaded after it
const db = getFirestore(firebase_app);

export { db };
